export default __webpack_public_path__ + "static/media/Rede_Super.efc65358.png";